import api from './axiosConfig';

export interface AlertData {
    id?: string;
    timestamp?: string;
    severity?: 'low' | 'medium' | 'high' | 'critical';
    message?: string;
    sourceIP?: string;
    description?: string;
    // Add other properties based on your actual alert structure
    [key: string]: any;
}

export interface DecodingAgentResponse {
    success: boolean;
    analysis?: string;
    error?: string;
}

export interface DecodingAgentError extends Error {
    status?: number;
}

/**
 * Calls the decoding agent API to process an alert
 * @param alertData - The alert data to be processed
 * @returns Promise containing the analysis result
 * @throws DecodingAgentError if the API call fails
 */
export const callDecodingAgent = async (alertData: AlertData): Promise<string> => {
    try {
        const response = await api.post('/decoding-agent', {
            alert: alertData
        });

        const data: DecodingAgentResponse = response.data;

        if (!data.success) {
            throw new Error(data.error || 'Unknown error occurred');
        }

        if (!data.analysis) {
            throw new Error('No analysis result received');
        }

        return data.analysis;

    } catch (error: any) {
        if (error.response?.data?.error) {
            const apiError = new Error(error.response.data.error) as DecodingAgentError;
            apiError.status = error.response.status;
            throw apiError;
        }
        if (error instanceof Error) {
            throw error;
        }
        throw new Error('An unexpected error occurred while calling the decoding agent');
    }
};
